import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { IInventoryModel } from 'src/app/shared/interfaces/IInventoryModel';
import { ILocationToExclude } from 'src/app/shared/interfaces/ILocationToExclude.interface';
import { PharmacyState } from 'src/app/shared/states/pharmacy/pharmacy.state';

@UntilDestroy()
@Component({
  selector: 'app-add-drug-dialog',
  templateUrl: './add-drug-dialog.component.html',
  styleUrls: ['./add-drug-dialog.component.scss', './../user-board-dialog.scss']
})
export class AddDrugDialogComponent  {

  @Output() save: EventEmitter<any> = new EventEmitter();
  @Output() cancel: EventEmitter<void> = new EventEmitter();
  @Output() back: EventEmitter<void> = new EventEmitter();
  
  @Input() show: boolean;
  @Input() ndcs: {ndc: string, locationID: string, drugID: string}[];
  @Input() ndcsToExclude: ILocationToExclude[];
  @Input() gpi: string = null;

  @ViewChild('submitButton') submitButton;
  @ViewChild('closeButton') closeButton;
  @ViewChild('inputChild') inputChild;

  @Select(PharmacyState.inventoryLocationsEnabled) inventoryLocationsEnabled$: Observable<boolean>;

  currentOption: any;
  errorMessage: string;
  isOptionSelected: boolean;
  isError: boolean;

  constructor(private store: Store) {
  }
 

  optionSelected(option: IInventoryModel): void {
    if (!option)
      return;

    this.isError = false;
    this.errorMessage = null;
    
    this.currentOption = option;
    this.isOptionSelected = true;
    if (!this.currentOption) {
      this.isError = true;
      this.errorMessage = "No inventory exists";
    } else if (this.currentOption && this.ndcs.some(x => x.locationID === option.locationID &&  x?.ndc === option?.packageNdc11Digits)) {
      this.errorMessage = "The drug is already added";
      this.isError = true;
    }

  }

  handleSearchInput(value: string): void {
    if (this.currentOption && !value) {
      this.currentOption = null;
    }
    
    if(!value) {
      this.isOptionSelected = false;
    }

    if(!this.isOptionSelected && value) {
      this.errorMessage = null;
      this.isError = false;
    }
  }


  saveDrug(): void {
    this.resetSearch();

    this.cancel.emit();
    this.save.emit(this.currentOption);
  }

  focusInput(inputName: string): void {
    setTimeout(() => this[inputName] && this[inputName]?.appInput?.nativeElement?.focus());
  }

  focusButton(buttonName: string): void {
    setTimeout(() => this[buttonName]?.focus());
  }

  close(): void {
    this.cancel.emit();
  }

  onBackHandler(): void {
    this.resetSearch();
    this.back.emit();
  }

  private resetSearch() {
    this.errorMessage = null;
    this.isError = false;
    this.inputChild.resetSearch();
  }
}
